// import { GeomFvAnimatedAbsoluteDiv } from "./FvAnimation";
// import { ReactComponent as Speaker } from "./svg/speaker.svg";
// import { ReactComponent as Bow } from "./svg/bow.svg";
// import { ReactComponent as Cloud1 } from "./svg/cloud1.svg";
// import { ReactComponent as Cloud2 } from "./svg/cloud2_1.svg";
// import { ReactComponent as Hat } from "./svg/hat.svg";
// import { ReactComponent as IceCream } from "./svg/icecream.svg";
// import { ReactComponent as Leaf } from "./svg/leaf.svg";
// import { ReactComponent as Mask } from "./svg/mask.svg";
// import { ReactComponent as Puppet } from "./svg/puppet.svg";
// import { ReactComponent as SunCloud } from "./svg/sun_cloud.svg";
// import { ReactComponent as Sun } from "./svg/sun.svg";
// import { ReactComponent as Window } from "./svg/window.svg";
import { Tween } from "react-gsap";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import styled from "styled-components";
import { useState } from "react";

gsap.registerPlugin(MotionPathPlugin);

const ZeroZeroDiv = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
`;

function randomXYArray(size, min, max) {
  const ra = [];
  const randWidthFactor = 2 + Math.random() * 10;
  for (let i = 0; i < size; i++) {
    ra.push({
      top: "" + gsap.utils.random(0, 95, 1) + "vh",
      left: "" + gsap.utils.random(0, 95, 1) + "vw",
      // x: Math.floor(Math.random() * (max - min)) + min,
      // y: Math.floor(Math.random() * (max - min)) + min,
      width: "" + i * randWidthFactor + "px",
    });
  }

  return ra;
}

function randomSubsetIndices(max, size) {
  if (max <= size) {
    return new Set([...Array(max).keys()]);
  }
  const indices = new Set();
  while (indices.size < size) {
    indices.add(Math.floor(Math.random() * max));
  }
  return indices;
}

function Drawings({ drawings, ...props }) {
  const [drawingIndices] = useState(
    randomSubsetIndices(drawings.length, drawings.length / 2)
  );
  return (
    <>
      {drawings.map((drawing, index) => (
        <>
          {drawingIndices.has(index) && (
            <Tween
              key={index}
              to={{
                motionPath: {
                  path: randomXYArray(100, -30, 30),
                  fromCurrent: true,
                  type: "cubic",
                  curviness: 2,
                  // relative: true,
                },
                duration: 4000,
                repeat: 200,
                yoyo: true,
                ease: "slow",
              }}
            >
              <ZeroZeroDiv>
                <img
                  key={drawing.path}
                  src={[process.env.PUBLIC_URL, drawing.path].join("/")}
                  width="50%"
                  alt={drawing.path
                    .substring(drawing.path.lastIndexOf("/") + 1)
                    .substring(0, -4)}
                ></img>
              </ZeroZeroDiv>
            </Tween>
          )}
        </>
      ))}
    </>
  );
}

export default Drawings;
